import type React from 'react'
import styled from 'styled-components'

import Button from '@/components/Button'
import TextAreaInput from '@/components/input/TextAreaInput'

interface Props {
  message: string
  onChangeMessage: (message: string) => void
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void
  sendboxText?: string
  onClose: () => void
}

const StyledTextAreaInput = styled(TextAreaInput)`
  height: 250px;
`

const StyledButton = styled(Button)`
  margin: 10px 10px 0px 0px;
`

const SendMessageForm: React.FC<Props> = ({
  message,
  onChangeMessage,
  handleSubmit,
  onClose,
  sendboxText = 'Write a new message...',
}) => (
  <form onSubmit={(e: React.FormEvent<HTMLFormElement>) => handleSubmit(e)}>
    <StyledTextAreaInput
      label={sendboxText}
      value={message}
      onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
        onChangeMessage(e.target.value)
      }
    />
    <div className="side-by-side-flex-start">
      <StyledButton type="button" $alternate onClick={onClose}>
        Back
      </StyledButton>
      <StyledButton
        type="submit"
        disabled={
          message.trim() == '' // eslint-disable-line eqeqeq
        }
      >
        Post
      </StyledButton>
    </div>
  </form>
)

export default SendMessageForm
